<template>
  <div class="image-block" :style="containerStyle">
    <img 
      :src="content" 
      :alt="alt"
      :style="imageStyle"
      @error="handleImageError"
    >
    <div v-if="caption" class="image-caption" :style="captionStyle">
      {{ caption }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageBlock',
  props: {
    content: {
      type: String,
      default: 'https://via.placeholder.com/600x200/3b82f6/ffffff?text=Imagen+de+Ejemplo'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: 'auto'
    },
    alt: {
      type: String,
      default: 'Imagen'
    },
    align: {
      type: String,
      default: 'center'
    },
    caption: {
      type: String,
      default: ''
    },
    captionAlign: {
      type: String,
      default: 'center'
    },
    captionColor: {
      type: String,
      default: '#6c757d'
    },
    captionSize: {
      type: String,
      default: '14px'
    },
    borderRadius: {
      type: String,
      default: '0px'
    },
    border: {
      type: String,
      default: 'none'
    },
    padding: {
      type: String,
      default: '10px'
    },
    margin: {
      type: String,
      default: '10px 0'
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    objectFit: {
      type: String,
      default: 'cover'
    },
    linkUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    containerStyle() {
      return {
        textAlign: this.align,
        padding: this.padding,
        margin: this.margin,
        backgroundColor: this.backgroundColor,
        borderRadius: this.borderRadius,
        width: '100%',
        boxSizing: 'border-box'
      }
    },
    imageStyle() {
      return {
        maxWidth: this.width,
        width: this.width === '100%' ? '100%' : this.width,
        height: this.height,
        borderRadius: this.borderRadius,
        border: this.border,
        objectFit: this.objectFit,
        display: 'block',
        margin: this.align === 'center' ? '0 auto' : 
               this.align === 'right' ? '0 0 0 auto' : '0'
      }
    },
    captionStyle() {
      return {
        fontSize: this.captionSize,
        color: this.captionColor,
        textAlign: this.captionAlign,
        marginTop: '8px',
        fontStyle: 'italic'
      }
    }
  },
  methods: {
    handleImageError(e) {
      e.target.src = 'https://via.placeholder.com/600x200/ef4444/ffffff?text=Error+al+cargar+imagen'
    }
  }
}
</script>

<style scoped>
.image-block {
  width: 100%;
}

.image-block img {
  max-width: 100%;
  height: auto;
  transition: all 0.3s ease;
}

.image-block img:hover {
  transform: scale(1.02);
}

.image-caption {
  margin-top: 8px;
  line-height: 1.4;
}

/* Para imágenes con enlace */
.image-block a {
  display: inline-block;
  text-decoration: none;
  transition: all 0.3s ease;
}

.image-block a:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style> 